import './AttachmentsIcon.css';
import * as React from 'react';
import { Attachment, buildSimpleAttachmentIconName, IAttachmentActions } from '../../../entities/Subentities';
import { ContextualMenuItemType, Icon, IconButton, IContextualMenuItem, Toggle } from 'office-ui-fabric-react';
import { getAttachmentUrl } from '../../views/list/columns/subentity/attachment/Title';
import { getDatePropComparer, notEmpty } from '../../utils/common';

const ITEMS_DISPLAY_COUNT = 10;

type Props = {
    readonly?: boolean;
    attachments: Attachment[];
    actions?: IAttachmentActions;
    showOnlyPinned: boolean;
    onShowOnlyPinnedChange: (value: boolean) => void;
    attachmentsMenuItem: IContextualMenuItem;
}

export const AttachmentsIcon = ({ attachmentsMenuItem, attachments, showOnlyPinned, onShowOnlyPinnedChange, actions, readonly }: Props) => {
    const ordered = (showOnlyPinned ? attachments.filter(_ => _.attributes.Pinned) : [...attachments]).sort(getDatePropComparer(_ => _.attributes.CreatedDate, false)).slice(0, ITEMS_DISPLAY_COUNT);
    return <IconButton
        className='attachments-icon'
        menuProps={{
            gapSpace: 10,
            calloutProps: { className: "attachments-header-icon-callout" },
            title: showOnlyPinned ? "Recent Pinned Attachments" : "Recent Attachments",
            items: ordered.map(_ => ({
                key: _.id,
                href: getAttachmentUrl(_, actions),
                target: "_blank",
                text: _.attributes.Name,
                title: _.attributes.Name,
                iconProps: { iconName: buildSimpleAttachmentIconName(_.attributes.Type) }
            }) as IContextualMenuItem).concat([
                readonly ? undefined : attachmentsMenuItem,
                {
                    key: "divider",
                    itemType: ContextualMenuItemType.Divider
                }].filter(notEmpty)),
            onRenderMenuList: (props, defaultRender) => <div className=''>
                {
                    defaultRender?.(props)
                }
                <div className='attachment-header-icon-menu-footer'>
                    <Icon iconName="Pinned" /><span>Pinned only</span><Toggle
                        checked={showOnlyPinned}
                        onChange={(e, checked) => onShowOnlyPinnedChange(!!checked)}>
                    </Toggle>
                </div>
            </div>
        }}
        iconProps={{ iconName: "PPMXHeaderAttachments" }}>
        <div className='progress-tip'>{attachments.length}</div>
    </IconButton>
}